<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>系统设置</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<el-input
							size="small"
							placeholder="输入组织名称搜索"
							prefix-icon="el-icon-search"
							style="width: 200px;"
							v-model="getdata.dw_name"
							@input="getdata.page = 1;totalPage = 0;dataList();">
						</el-input>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="hyid"
                            :tableHeader="tableHeader"
                            :loading="true" 
							:indexs="false"
							:selection="false"></myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/tree.vue'
	import { xtsz } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import myTables from '@/components/tables/tables.vue'
	export default{
		data(){
			return{
				getdata:{
					user_id:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					status: "",
					dw_name: "",
					auth: "",
					page: 1,
				},
				tableData:[],
				tableHeader: [     // 表头
					{prop: 'username', label: '登陆账号'},
					{prop: 'dw', label: '党组织',width:"160"},
					{prop: 'head_name', label: '负责人',width:"150"},
					{prop: 'uptime', label: '登陆时间',width:'150',formatData:(val) => {
						return this.$changeTime(val)
					}},
					{prop: 'ip', label: '登陆IP',width:'150'}
				],
				totalPage:0
			}
		},
		components:{tree,Page,myTables},
		methods:{
			// 数据
			dataList(){
				var that = this;
				that.tableData = [];
				xtsz.loginLog(that.getdata).then(res => {
					that.tableData = res.data.pagedata;
					that.totalPage = res.data.count;
				})
			},
			// 树形结构筛选
			treeSelect(data){
				var that = this;
				that.getdata.user_id = data.id;
				that.getdata.flag = data.flag;
				that.getdata.page = 1;
				that.dataList();
			},
			// 分页筛选
			changedata(curret){
				var that = this;
				that.getdata.page = curret;
				that.dataList();
			},
		},
		mounted() {
			var that = this;
			that.dataList();
		},
		created() {
			var that = this;
			that.$emit('selectTop',7)
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.fengmian {
		    height: 86px;
		    width: 150px;
			object-fit: cover;
		}
	}
</style>

